"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePrice_1 = require("./usePrice");
var PriceTypes_1 = require("../../../../../../common/enum/PriceTypes");
var useTotalPrices = function (totalPrice) {
    var netPrices = totalPrice.filter(function (price) { return price.type === PriceTypes_1.PriceTypes.NET_PRICE; });
    var finalPrices = totalPrice.filter(function (price) { return price.type === PriceTypes_1.PriceTypes.FINAL_PRICE; });
    var _a = usePrice_1.default(netPrices), primaryTotalNetPrice = _a.primaryPrice, secondaryTotalNetPrice = _a.secondaryPrice;
    var _b = usePrice_1.default(finalPrices), primaryTotalFinalPrice = _b.primaryPrice, secondaryTotalFinalPrice = _b.secondaryPrice;
    var totalPrices = {
        totalNetPrices: [primaryTotalNetPrice, secondaryTotalNetPrice],
        totalFinalPrices: [primaryTotalFinalPrice, secondaryTotalFinalPrice],
    };
    return totalPrices;
};
exports.default = useTotalPrices;
